import type { SearchHit, SearchResponse } from '../../contracts/src/search.js';
import { cosineDistance } from './distance.js';

export interface VectorEntry {
  readonly id: string;
  readonly vector: Float32Array;
}

export function exactSearch(entries: readonly VectorEntry[], query: ArrayLike<number>, k: number): SearchResponse {
  const startedAt = performance.now();
  const ranked = entries
    .map((entry) => ({ id: entry.id, distance: cosineDistance(entry.vector, query) }))
    .sort((left, right) => left.distance - right.distance)
    .slice(0, k)
    .map<SearchHit>((hit, index) => ({ ...hit, rank: index + 1 }));

  return {
    hits: ranked,
    trace: {
      entryPointId: entries[0]?.id ?? null,
      visitedIds: entries.map((entry) => entry.id),
      edges: [],
      distanceCalculations: entries.length,
      layersTraversed: 1
    },
    elapsedMs: performance.now() - startedAt,
    inspectedRatio: entries.length === 0 ? 0 : 1
  };
}
